import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RadioButton } from 'primereact/radiobutton'

import { Button } from '../../../helpers'

import { downloadBuyerInvoice } from '../../../services/api/buyerInvoice'
import { raiseToast } from '../../../services/redux/reducers/toast/toast'


const DownloadInvoice = (props) => {
    const { buyerInvoice, buyerBillAddrDetails, docItemReplacementMap, buyerInvoiceItems, setIsLoading, eWayBill } = props

    const [pdfType, setPdfType] = useState("")

    const HSNMaster = useSelector((state) => state.common.HSNMaster)
    const dispatch = useDispatch()

    const handleDownloadInvoice = async () => {
        if(!pdfType){
            return dispatch(raiseToast({ severity: 'error', detail: "Please select pdf type", life: 3000 }))
        }

        if(Date.parse(buyerInvoice.createdAt) >= Date.parse(new Date(2024,10,1)) && buyerInvoice.totalInvAmount > 50000 && eWayBill.length === 0){
            let isVoucherInvoice = buyerInvoiceItems.every(eachInvoiceItem => {
                const relatedHSNDetails = HSNMaster.find(eachHSN => eachHSN.HSNCode == eachInvoiceItem.HSNCode)
                if(relatedHSNDetails && relatedHSNDetails.tags?.isVoucher){
                    return true
                }
                return false
            })
            if(!isVoucherInvoice && docItemReplacementMap?.length){
                isVoucherInvoice = docItemReplacementMap.every(eachMapItem => {
                    const relatedHSNDetails = HSNMaster.find(eachHSN => eachHSN.HSNCode == eachMapItem.HSNCode)
                    if(relatedHSNDetails && relatedHSNDetails.tags?.isVoucher){
                        return true
                    }
                    return false
                })
            }
            let isServiceInvoice = buyerInvoiceItems.every(eachInvoiceItem => eachInvoiceItem.HSNCode.toString().slice(0, 2) === "99")
            if(!isServiceInvoice && docItemReplacementMap?.length){
                isServiceInvoice = docItemReplacementMap.every(eachMapItem => eachMapItem.HSNCode.toString().slice(0, 2) === "99")
            }
            if(!(isServiceInvoice || isVoucherInvoice)){
                return dispatch(raiseToast({ severity: 'error', detail: "E-Way bill is missing. please upload e-way bill", life: 3000 }))
            }
        }

        setIsLoading(true)
        const downloadResponse = await downloadBuyerInvoice(buyerInvoice?.docNo, pdfType)
        const ssh = new Uint8Array(downloadResponse.data.data)

        var blob=new Blob([ssh], {type: "application/pdf"});
        var link=document.createElement('a');
        link.href=window.URL.createObjectURL(blob);
        link.download=`Invoice_${buyerInvoice.docNo}_${buyerBillAddrDetails.companyName}.pdf`; 
        link.click();

        if (downloadResponse?.failure) {
            return dispatch(raiseToast({ severity: 'error', summary: 'Buyer Invoice', detail: downloadResponse?.data?.error, life: 3000 }))
        }
        setIsLoading(false)
    }

    const handlePdfTypeChange = (e) => {
        setPdfType(e.target.value)
    }

    return (
        <div className='flex flex-row col-12 pb-0 justify-content-between'>
            <div className='flex flex-column col-12'>
                <div className='flex flex-row mt-2'>
                    <RadioButton inputId="WITH_OUT_STAMP" name="pdfType" value="WITH_OUT_STAMP" onChange={handlePdfTypeChange} checked={pdfType === "WITH_OUT_STAMP"} />
                    <label htmlFor="WITH_OUT_STAMP" className="p-radiobutton-label">With out stamp and signature</label>
                </div>

                <div className='flex flex-row mt-2'>
                    <RadioButton inputId="WITH_STAMP" name="pdfType" value="WITH_STAMP" onChange={handlePdfTypeChange} checked={pdfType === "WITH_STAMP"} />
                    <label htmlFor="WITH_STAMP" className="p-radiobutton-label">With stamp and signature</label>
                </div>

                <div className='flex flex-row mt-2'>
                    <RadioButton inputId="DIGITALLY_SIGNED" name="pdfType" value="DIGITALLY_SIGNED" onChange={handlePdfTypeChange} checked={pdfType === "DIGITALLY_SIGNED"} required />
                    <label htmlFor="DIGITALLY_SIGNED" className="p-radiobutton-label">Digitally Signed</label>
                </div>

                <div className='flex flex-row justify-content-center'>
                    <Button label="Download" onClick={handleDownloadInvoice} />
                </div>
            </div>
        </div>
    )
}

export default DownloadInvoice